import { base_url } from "../../helper/common-vars";

// import { Visualzier } from "../helper/visualzier";
// import { Setting } from "../helper/settings";

export const loadWidget = (script_id) => {
  let url =
    base_url +
    "/vr/api/visualizer/widgetV2/id/" +
    script_id +
    "/newUI2?common_ui=1&v=3.67307";

  return {
    serviceName: url,
    method: "script",
    onLoad: { type: "" },
    onSuccess: (data) => {
      let window_copy: any = window;
      return [
        {
          type: "Set_Widget_Data",
          VisualizeROI: window_copy.VisualizeROI,
        },
      ];
    },
    onFailure: (data) => {},
  };
};

export const GetTemplate = (id) => {
  let url = base_url + "/vr/api/SelfService/GetTemplate/id/" + id;
  return {
    serviceName: url,
    method: "get",
    onLoad: { type: "" },
    onSuccess: (data) => {
      return { type: "SET_PDF_JSON", payload: data.data.PDF_JSON };
    },
    onFailure: (data) => {},
  };
};

export const getExtensionScript = (id) => {
  let url =
    base_url +
    "/vr/api/visualizer/gettagsextensions/id/" +
    id +
    "/type/script?v=7.2647";
  var script = document.createElement("script");
  script.onload = function () {
    return { type: "Do_Nothing" };
  };
  script.src = url;
  document.head.appendChild(script);
};

export const getExtensionTag = (id) => {
  let url = base_url + "/vr/api/visualizer/gettagsextensions/id/" + id;
  return {
    serviceName: url,
    method: "get",
    onLoad: { type: "" },
    onSuccess: (data) => {
      return { type: "Set_Tag_Extension", tag_extension: data.tag_extension };
    },
    onFailure: (data) => {},
  };
};

export const calculate_fun = (
  event,
  code_ref,
  visualizer_input_output_values,
  calculate
) => {
  let visualizer_input_output_values_copy = Object.assign(
    {},
    visualizer_input_output_values.inputs
  );

  let field_value =
    typeof event == "number" ? event : event.target.value.replace(/[,$]/g, "");
  visualizer_input_output_values_copy[code_ref] = field_value;

  let calculated_values = calculate(visualizer_input_output_values_copy);

  return {
    type: "Set_Input_Output_Values",
    calculated_values: calculated_values,
  };
};
